import { dashboardApi } from '@/api';

interface UpdateCampaignArgs {
    projectId: string;
    campaignId: string;
    comment?: string;
}

export const requestCampaignReview = async ({
    projectId,
    campaignId,
    comment = '',
}: UpdateCampaignArgs) => {
    await dashboardApi({
        method: 'PATCH',
        url: `/customer-campaign/project/${projectId}/campaign/${campaignId}/review`,
        data: {
            comment,
        },
    });
};
